import _ from 'lodash';
const { GET_PROFILE, PROFILE_ERROR, REMOVE_ONE_EXP, CHANGE_PROF_PIC, OPEN_EDIT_DETAILS,
CLEAR_PROFILE, MAKE_FOLLOWING, MAKE_UNFOLLOWING, UPDATE_ONE_EXP, GET_FOLLOWERS,
ADD_ONE_EXP, UPDATE_PROFILE_EXPS, GET_FOLLOWING, SET_LOADING_TRUE,
UPDATE_USER_INFO } = require('../types');

const INITIAL_STATE = {
  userInfo: null,
  isFollowing: false,

  loadedExps: [],  
  flags: [],
  
  followersCount: null,
  followingCount: null,
  expsCount: null,
  
  followers: [],
  following: [],
  showFollowers: false,
  showFollowing: false,

  updatedItems: null,
  
  userIdParam: null,
  pageNum: 2,
  
  error: null,
  loading: true,
  changeProfPic: false,
  inProfilePage: false,
  editDetailsIsOpen: false
};

const profileReducer = (state=INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch(type) {
    case GET_PROFILE:
      return {
        ...state, 
        userInfo: payload.a.userInfo,

        isFollowing: payload.a.threeInfo[0],
        followingCount: payload.a.threeInfo[1], 
        followersCount: payload.a.threeInfo[2],
        
        expsCount: payload.a.flags.length,

        showFollowers: false,
        showFollowing: false,

        loadedExps: payload.a.userExperiences,
        flags: _.uniq(payload.a.flags),

        userIdParam: payload.b,
        loading: false,
        inProfilePage: true 
      }
    case PROFILE_ERROR: 
      return {
        ...state,
        error: payload.message,
        loadedExps: [],
        userInfo: null,
        loading: false
      }
    case UPDATE_USER_INFO: 
      return {
        ...state,
        userInfo: payload,
        editDetailsIsOpen: false
      }
    case UPDATE_PROFILE_EXPS:
      return { 
        ...state,
        loadedExps: [...state.loadedExps, ...payload],
        pageNum: state.pageNum + 1,
        updatedItems: payload.length,
        loading: false 
      }
    case SET_LOADING_TRUE: 
      return {
        ...state,
        loading: true
      }
    case OPEN_EDIT_DETAILS:
      return {
        ...state,
        editDetailsIsOpen: payload
      }
    case ADD_ONE_EXP:
      return {
        ...state,
        loadedExps: [payload, ...state.loadedExps],  
        loading: false
      }
    case REMOVE_ONE_EXP:
      return {
        ...state,
        loadedExps: state.loadedExps.filter(exp => exp._id !== payload),
        loading: false
      }
    case GET_FOLLOWERS:
      return {
        ...state,
        followers: payload,
        showFollowers: true,
        loading: false
      }
    case GET_FOLLOWING:
      return {
        ...state,
        following: payload, 
        showFollowing: true,
        loading: false
      }
    case CLEAR_PROFILE:
      return {
        ...state,
        userInfo: null,
        loadedExps: [],
        flags: [],
        userIdParam: null,
        followersCount: null,
        followingCount: null,
        followers: [],
        following: [],
        showFollowers: false,
        showFollowing: false,
        expsCount: null,
        pageNum: 2,
        error: null,
        loading: true,
        isFollowing: false,
        updatedItems: null,
        changeProfPic: false,
        inProfilePage: false,
      }
    case MAKE_FOLLOWING:
      return {
        ...state,
        isFollowing: true,
        followersCount: ++state.followersCount
      }
    case MAKE_UNFOLLOWING:
      return {
        ...state,
        isFollowing: false,
        followersCount: --state.followersCount
      }
    case CHANGE_PROF_PIC:
      return {
        ...state,
        changeProfPic: payload
      }
    case UPDATE_ONE_EXP:
      let index = state.loadedExps.findIndex(exp => exp._id === payload._id);
      state.loadedExps.splice(index, 1, payload); 
      return {
        ...state,
        loadedExps: [...state.loadedExps],
        loading: false
      }
    default:
      return state;
  }
  
}


export default profileReducer;